// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import model_1 from '/data/heran/operation-front-end/operation-front-end-docker-sys_prod_gy/src/models/global';
import model_2 from '/data/heran/operation-front-end/operation-front-end-docker-sys_prod_gy/src/pages/App/models/info';
import model_3 from '/data/heran/operation-front-end/operation-front-end-docker-sys_prod_gy/src/pages/Cust/CustInfo/models/index';
import { useQiankunStateForSlave as model_4 } from '/data/heran/operation-front-end/operation-front-end-docker-sys_prod_gy/src/app';

export const models = {
model_1: { namespace: 'global', model: model_1 },
model_2: { namespace: 'App.info', model: model_2 },
model_3: { namespace: 'Cust.CustInfo.index', model: model_3 },
model_4: { namespace: '@@qiankunStateForSlave', model: model_4 },
} as const
